import { j as r } from "../jsx-runtime-Wav_3Wde.js";
import { s as c } from "../index.esm-DOxVcNnO.js";
import { styled as i, css as l } from "styled-components";
import { compose as m, color as p, layout as d, space as f } from "styled-system";
const u = /* @__PURE__ */ i.span.withConfig({
  shouldForwardProp: (o) => c(o)
}).withConfig({
  componentId: "sc-21a8b5ea-0"
})([
  "",
  ""
], ({ theme: o }) => /* @__PURE__ */ l([
  "",
  " ",
  ""
], o.components.icon.base, m(p, d, f))), h = {
  role: "img",
  "aria-hidden": !0,
  focusable: !1
}, g = ({ color: o = "currentColor", IconSvg: s, svgProps: t, size: e = 24, iconAttributes: a = h, ...n }) => /* @__PURE__ */ r.jsx(u, {
  color: o,
  size: e,
  ...n,
  children: /* @__PURE__ */ r.jsx(s, {
    ...a,
    ...t
  })
});
export {
  u as StyledIcon,
  g as default
};
